import { useContext } from "react";
import styled, { css } from "styled-components";
import ExpirationDate from "../../../../sharable/ExpirationDate";
import WorkspaceContext from "../../../WorkspaceContext";
import {
  CARTAZ_GRANDE,
  CARTAZ_MEDIO,
  CARTAZ_PEQUENO,
} from "../../EncarteConstants";

// ─── Styled wrappers ─────────────────────────────────────────────────────────

const ExpiryDateFontSizeByFormat = {
  [CARTAZ_PEQUENO]: 20,
  [CARTAZ_MEDIO]: 24,
  [CARTAZ_GRANDE]: 45,
};

const CartazDateOnlyWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ canvasScale, styles }) => {
    return css`
      .expiry-date {
        font-size: ${ExpiryDateFontSizeByFormat[styles.format] * canvasScale}px;

        padding: 0 ${20 * canvasScale}px ${50 * canvasScale}px
          ${10 * canvasScale}px;
        .date-highlight {
          font-size: ${ExpiryDateFontSizeByFormat[styles.format] *
          canvasScale}px;
          background-color: #ffffff;
          color: #111111;
          padding: 0;
          margin: 0;
          font-weight: 500;
          text-decoration: underline;
        }
      }
    `;
  }}

  .expiry-date {
    background-color: #ffffff;
    color: #111111;
    width: 100%;
  }
`;

// ─── Sub-components ───────────────────────────────────────────────────────────

export const CartazDateOnlyFooterStyle = ({
  encarte,
  headerAndFooterStyles,
  canvasScale,
  styles,
}) => {
  return (
    <CartazDateOnlyWrapper canvasScale={canvasScale} styles={styles}>
      <ExpirationDate
        endDate={encarte.endDate}
        startDate={encarte.startDate}
        styles={headerAndFooterStyles}
        scale={canvasScale}
        className={"expiry-date"}
      />
    </CartazDateOnlyWrapper>
  );
};

// ─── Main component ───────────────────────────────────────────────────────────

export default function CartazFooterStyles({
  headerAndFooterStyles,
  canvasScale,
}) {
  const { encarte, styles } = useContext(WorkspaceContext);

  switch (styles.footerStyle) {
    case "DATE_ONLY":
      return (
        <CartazDateOnlyFooterStyle
          encarte={encarte}
          styles={styles}
          headerAndFooterStyles={headerAndFooterStyles}
          canvasScale={canvasScale}
        />
      );
    case "HIDDEN":
      return null;
    default:
      return null;
  }
}
